
import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface HeaderProps {
  onBack?: () => void;
  showBackButton?: boolean;
}

const Header = ({ onBack, showBackButton = false }: HeaderProps) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            {showBackButton && onBack && (
              <button
                onClick={onBack}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
            )}
            <div className="flex items-center space-x-3">
              {/* Logo da Decide Digital */}
              <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-700 rounded-xl flex items-center justify-center shadow-md">
                <span className="text-white font-bold text-xl tracking-tight">DD</span>
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900 tracking-tight">Decide Digital</h1>
                <p className="text-sm text-gray-600 font-medium">Agência Digital Especializada</p>
              </div>
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-2 text-sm text-gray-500">
            <span className="font-medium">decidedigital.com.br</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
